<template>
    <div class="k-flex-col">
        <div class="k-flex-row">
            <div class="flex-grow-1 mr-4">
                <b-input-group>
                    <template #prepend>
                        <b-input-group-text>
                            <b-icon-search />
                        </b-input-group-text>
                    </template>
                    <b-form-input
                        placeholder="Rechercher un utilisateur"
                        v-model="filter"
                        debounce="500"
                    />
                </b-input-group>
            </div>
            <div class="d-flex flex-column">
                <small class="text-kalkin-1 text-center w-100">
                    Utilisateurs par page
                </small>
                <b-form-group>
                    <b-form-radio-group
                        v-model="perPage"
                        size="sm"
                        button-variant="outline-kalkin-1"
                        buttons
                    >
                        <b-form-radio :value="5">5</b-form-radio>
                        <b-form-radio :value="10">10</b-form-radio>
                        <b-form-radio :value="20">20</b-form-radio>
                        <b-form-radio :value="50">50</b-form-radio>
                        <b-form-radio :value="100">100</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
        </div>
        <b-table
            class="text-break mt-2 text-center"
            :items="dataProvider"
            :fields="fields"
            :current-page="currentPage"
            :filter="filter"
            :per-page="perPage"
            show-empty
            empty-text="Aucun utilisateur"
            empty-filtered-text="Aucun utilisateur trouvé"
            stacked="md"
            hover
            tbody-tr-class="pointer"
            @row-clicked="goUserProfile"
            striped
        >
            <template #table-busy>
                <div class="text-center my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="ml-2">Chargement des données...</strong>
                </div>
            </template>
            <template #cell(lastName)="data">
                <b class="text-kalkin-1"
                    >{{ data.item.firstName }}
                    {{ data.item.lastName.toUpperCase() }}</b
                >
            </template>
            <template #cell(credentials)="data">
                <img
                    v-if="data.item.credentials >= 5"
                    src="@/assets/favicon-kalkin.png"
                    class="icon-kalkin"
                />

                {{ data.item.credentials | userRoleFromCreds }}
            </template>
            <template #cell(createdAt)="data">
                {{ data.item.createdAt | dateFromISO }}
            </template>
            <template #cell(connectedAt)="data">
                <template v-if="data.item.connectedAt">
                    {{ data.item.connectedAt | daysSinceISO }}
                </template>
            </template>
        </b-table>
        <div>
            <b-pagination
                class="m-auto"
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalRows"
                align="center"
                size="sm"
                first-number
                last-number
            />
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            fields: [
                {
                    key: "lastName",
                    label: "Identité",
                    sortable: true,
                },
                {
                    key: "credentials",
                    label: "Rôle",
                    sortable: true,
                },
                {
                    key: "mail",
                    label: "Email",
                    sortable: true,
                },
                {
                    key: "createdAt",
                    label: "Création",
                    sortable: true,
                },
                {
                    key: "connectedAt",
                    label: "Dernière connexion",
                    sortable: true,
                },
            ],
            filter: "",
        };
    },

    watch: {
        async filter() {
            await this.fetchTotalRows();
        },
    },

    methods: {
        async fetchTotalRows() {
            this.totalRows = await this.$store.dispatch("user/countFSPUsers", {
                filter: `firstName substring ${this.filter} or lastName substring ${this.filter}`,
            });
        },

        async dataProvider(ctx) {
            return await this.$store.dispatch("user/getFSPUsers", {
                filter: `firstName substring ${this.filter} or lastName substring ${this.filter}`,
                sortby: (ctx.sortDesc ? "-" : "") + ctx.sortBy,
                limit: this.perPage,
                offset: this.perPage * (this.currentPage - 1),
            });
        },

        goUserProfile(item) {
            this.$router.push({
                name: "AdminUser",
                params: { userId: item.id },
            });
        },
    },

    async beforeMount() {
        await this.fetchTotalRows();
    },
};
</script>

<style lang="scss">
.icon-kalkin {
    width: 14px;
    height: 14px;
    margin-bottom: 4px;
}
</style>
